// RegisterClientController
app.controller('RegisterClientController', ['$scope', '$location', 'WdHttpService', 'sessionService', 'config', '$timeout', '$window', 'analyticsService',
    function($scope, $location, WdHttpService, sessionService, config, $timeout, $window, analyticsService) {

        $scope.init = async function() {
            $scope.registrationSteps = [true, false, false, false, false];
            $scope.path = $location.search().path;
            if ($location.search().brokerName) {
                $scope.selectedBroker = $location.search().brokerName;
            }

            $scope.actionPage = $location.search().action;
            $scope.path = $location.search().path;
            $scope.sendOTP = true;
        }

        $scope.registrationPage = function(value) {
            for (let index = 0; index < $scope.registrationSteps.length; index++) {
                if ($scope.registrationSteps[index]) {
                    $scope.registrationSteps[index] = false
                    if (value > 0)
                        $scope.registrationSteps[index + 1] = true
                    else
                        $scope.registrationSteps[index - 1] = true
                    break
                }
            }

            if ($scope.$parent.errorLineDisplayFlag) {
                $scope.$parent.errorLineDisplayFlag = false;
                $scope.$parent.errorMsg = undefined;
            }
        }

        $scope.changeRegistrationPageTo = function(value) {
            for (let index = 0; index < $scope.registrationSteps.length; index++) {
                if (index == value) {
                    $scope.registrationSteps[index] = true;
                } else {
                    $scope.registrationSteps[index] = false;
                }
            }

            if ($scope.$parent.errorLineDisplayFlag) {
                $scope.$parent.errorLineDisplayFlag = false;
                $scope.$parent.errorMsg = undefined;
            }
        }

        $scope.registerClient = async function(form) {
            if (form.$invalid) {
                $scope.showErrorPopup('Please enter valid input and try again.');
                return;
            }

            if (!form.email.$modelValue && !form.mobile.$modelValue) {
                $scope.showErrorPopup('Please enter valid Email address or Mobile, its mandatory.');
                return;
            }

            $scope.investorUsername = generateUsername(form);
            var data = {
                "name": form.name.$modelValue,
                "username": $scope.investorUsername,
            }

            if (form.email.$modelValue)
                data.email = form.email.$modelValue;
            if (form.mobile.$modelValue)
                data.phoneNumber = "+91" + form.mobile.$modelValue;


            $scope.showLoading("#page1 > form > button");
            WdHttpService._user_register(data)
                .then(async response => {
                    $scope.registrationPage(1);
                    $scope.stopLoading("#page1 > form > button");
                    RegistrationStep('filledPersonalDetails-registrationStep1', "")
                })
                .catch(error => {
                    console.log(error);
                    if (error.includes("User account already exists") ||
                        error.includes("You are already registered, You need to set your new password now.")) {
                        var data = { username: $scope.investorUsername };
                        WdHttpService._resend_activation(data)
                            .then(function(response) {
                                $scope.registrationPage(1);
                                $scope.stopLoading("#page1 > form > button");
                                RegistrationStep('filledPersonalDetails-registrationStep1', "")
                            }).catch(error => {
                                $scope.showRegisterError(error);
                            });
                    } else {
                        $scope.showRegisterError(error);
                    }
                    $scope.stopLoading("#page1 > form > button");
                    RegistrationStep('filledPersonalDetails-registrationStep1', error)

                });
        }

        $scope.verifyOtp = function(form) {

            var data = { password: form.otpNumber.$modelValue, username: $scope.investorUsername };
            $scope.showLoading("#page2 > form > button");
            WdHttpService._log_in(data)
                .then(async response => {
                    if (response.data.challengeName == 'NEW_PASSWORD_REQUIRED') {
                        $scope.sessionCode = response.data.session;
                        $scope.registrationPage(2);
                        $scope.stopLoading("#page2 > form > button");
                        RegistrationStep('OTPConfirmation-registrationStep2', "")
                    }
                })
                .catch(error => {
                    if (error == 'Incorrect username or password.')
                        error = 'Incorrect OTP has been entered';
                    else if (extractAWSString(error).includes("Invalid session for the user, session is expired.")) {
                        error = extractAWSString(error) + ' Please click resend OTP and try again.';
                        // OTP Expires in 5 mins
                    }
                    console.log(error);
                    $scope.showRegisterError(error);
                    $scope.stopLoading("#page2 > form > button");
                    RegistrationStep('OTPConfirmation-registrationStep2', error)
                });
        }

        $scope.resendPassword = function() {
            if ($scope.sendOTP) {
                var data = { username: $scope.investorUsername };
                $scope.showLoading("#page2 > form > button");
                WdHttpService._resend_activation(data)
                    .then(function(response) {
                        $scope.sendOTP = false;
                        $scope.otpSend = true;
                        $scope.stopLoading("#page2 > form > button");
                    });
            }

            $timeout(function() {
                $scope.sendOTP = true;
                $scope.otpSend = false;
            }, 1000 * 60);
        }

        $scope.setnewpassword = function(form) {

            var data = {
                newPassword: form.userpassword.$modelValue,
                username: $scope.investorUsername,
                session: $scope.sessionCode
            };
            $scope.showLoading("#page3 > form > button");
            WdHttpService._set_new_password(data)
                .then(async function(response) {
                    $scope.registrationPage(3);
                    var data = {
                        username: $scope.investorUsername,
                        password: $scope.userpassword
                    }
                    await WdHttpService._log_in(data)
                        .then(response => {
                            $scope.setUserSession(sessionService, response);
                            sessionService.set("investingMode", "REAL");
                            $scope.prepareBrokerLinks('', "updateBrokerProfile", true);
                            $scope.stopLoading("#page3 > form > button");
                            RegistrationStep('setPassword-registrationStep3', "")
                        });
                }).catch(error => {
                    console.log(error);
                    if (extractAWSString(error).includes("Invalid session for the user, session is expired.")) {
                        $scope.changeRegistrationPageTo(1);
                        error = extractAWSString(error) + ' Please click resend OTP and try again.';
                        // OTP Expires in 5 mins
                    }
                    $scope.showRegisterError(error);
                    $scope.stopLoading("#page3 > form > button");
                    RegistrationStep('setPassword-registrationStep3', error)
                });
        }

        $scope.updateBroker = function(form) {
            if (form.brokerName.$modelValue) {
                // TODO Ask for client Code or not ?
                var data = {
                    "clientCode": "",
                    "panCard": "",
                    "phoneNumber": "",
                    "brokerName": form.brokerName.$modelValue,
                    "email": "",
                }
                $scope.showLoading("#selectBrokerContinueButtonRegistration");
                WdHttpService._update_profile(data)
                    .then(async function(response) {
                        RegistrationStep('registrationCompleted-registrationStep4', "")
                        $scope.stopLoading("#selectBrokerContinueButtonRegistration");
                        $scope.showSuccessPopup("Congratulations, you've signed up successfully. Happy Investing");
                        var actionPage = $location.search().action;
                        var path = $location.search().path;
                        if (actionPage) {
                            $scope.sendToActionPage(actionPage);
                        } else if (path) {
                            $scope.handleRedirectionPath(path);
                        } else {
                            $scope.registrationPage(4);
                        }
                    }).catch(error => {
                        console.log(error);
                        RegistrationStep('failed', error)
                        $scope.showRegisterError(error);
                        $scope.stopLoading("#selectBrokerContinueButtonRegistration");
                    });
            } else {
                $scope.showErrorPopup("Broker selection is required.");
            }
        }

        $scope.endProcess = function() {
            $scope.showSuccessPopup("Congratulations, you've signed up successfully. Happy Investing");
            $scope.registrationPage(4);
        }

        $scope.handleNormalSignIn = function(brokerName) {

            // if brokerName is undefined or Not
            if (brokerName) {
                if (config.BROKERS.indexOf(brokerName) > -1) {
                    $window.location.href = config[brokerName].brokerPage + "?path=/fund-discovery&token=" + sessionService.get('refresh');
                    return;
                }
            }

            $location.path("/fund-discovery");
            // $location.path("/kyc");
        }

        $scope.handleRedirectionPath = function(path) {
            var returnToken = $location.search().returnToken;
            if (returnToken === "true" && $location.absUrl().replace($location.url(), "").includes(location.host)) {
                returnToken = false;
            }
            if (returnToken === "true") {
                var sign = '&';
                if (!path.includes("?"))
                    sign = '?';
                $window.location.href = path + sign + 'token=' + sessionService.get('refresh');
            } else {
                $window.location.href = path;
            }
        }

        $scope.sendToActionPage = async function(actionPage) {
            if (actionPage == 'holdingsAnalyse') {
                await WdHttpService._qc_login().then(response => {
                    $scope.$parent.isQcLoggedIn = true;
                })
                window.location = config.QC_ANALYZER_URL + "/upload-data?&qcAuth=" + btoa(sessionService.get("qcLogin").idToken) + "&wdAuth=" + btoa(sessionService.get("id")) + "&expiresIn=" + btoa(sessionService.get("qcExpiresIn"));
            } else {
                $location.path('/' + actionPage).search({});
            }
        }

        $scope.showRegisterError = function(error, elementId = undefined) {
            error = extractAWSString(error);
            $scope.$parent.errorLineDisplayFlag = true;
            $scope.$parent.errorMsg = error;
            $timeout(function() {
                $scope.$parent.errorLineDisplayFlag = false;
                $scope.$parent.errorMsg = undefined;
            }, 1000 * 10);

            if (elementId)
                $scope.stopLoading(elementId);
        }

        $scope.validateUsernameOnBlur = async function(username, form) {
            if (username) {
                $scope.showLoadingSpinner = true;
                await WdHttpService._get_user_full_name({ 'username': username })
                    .then(response => {
                        $scope.usernameInvalidate = true;
                        form.username.$invalid = true;
                        $scope.showLoadingSpinner = false;
                    }).catch(error => {
                        $scope.usernameInvalidate = false;
                        form.username.$invalid = false;
                        $scope.showLoadingSpinner = false;
                    });
            }
        }

        function generateUsername(form) {
            if (form.mobile.$modelValue) {
                return String(String(form.name.$modelValue).substr(0, 9) + form.mobile.$modelValue)
                    .toString().replace(/\s/g, '').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').toLowerCase();
            }

            if (form.email.$modelValue) {
                return String(form.email.$modelValue)
                    .toString().replace(/\s/g, '').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').toLowerCase();
            }
        }

        function extractAWSString(error) {
            if (error.indexOf(" (Service: AWSCognitoIdentityProvider") > 0)
                error = error.substr(0, error.indexOf(" (Service: AWSCognitoIdentityProvider"));
            return error;
        }

        async function RegistrationStep(stepno, error) {
            var eventData = {};
            if (error) {
                eventData = {
                    'event': 'Registration Step ' + stepno.toString() + ' error',
                    'target': 'Registration Step ' + stepno.toString() + ' error',
                    'target_properties': JSON.stringify(error)
                }
            } else {
                eventData = {
                    'event': 'Registration Step ' + stepno.toString(),
                    'target': 'Registration Step ' + stepno.toString(),
                    'target_properties': 'Registration Step ' + stepno.toString()
                }
            }
            if (stepno == 'registrationCompleted-registrationStep4') {
                await analyticsService._push_custom_event_data_to_datalayer('registration-step-' + stepno.toString().toLowerCase(), eventData);
            } else {
                analyticsService._push_custom_event_data_to_datalayer('registration-step-' + stepno.toString().toLowerCase(), eventData);
            }
        }
    }
]);